import { render, staticRenderFns } from "./EditTenant.vue?vue&type=template&id=3b837d6b&"
import script from "./EditTenant.vue?vue&type=script&lang=js&"
export * from "./EditTenant.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports